import {
  publishers,
  brands,
  keywords,
  content,
  hubs,
  categories,
} from 'api';

import {
  FETCH_BRANDS_LIST,
  FETCHED_BRANDS_LIST,
  FETCH_PUBLISHERS_LIST,
  FETCHED_PUBLISHERS_LIST,
  FETCH_KEYWORDS_LIST,
  FETCHED_KEYWORDS_LIST,
  FETCH_CATEGORIES_LIST,
  FETCHED_CATEGORIES_LIST,
} from 'components/Global/Filters/actions.js';

import { fetchPayload, fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

export const FETCH_BRAND_METADATA = 'FETCH_BRAND_METADATA';
export const FETCHED_BRAND_METADATA = 'FETCHED_BRAND_METADATA';

export const FETCH_BRAND_PAID_CONTENT = 'FETCH_BRAND_PAID_CONTENT';
export const FETCHED_BRAND_PAID_CONTENT = 'FETCHED_BRAND_PAID_CONTENT';
export const SET_BRAND_PAID_CONTENT_FILTER = 'SET_BRAND_PAID_CONTENT_FILTER';

export const FETCH_BRAND_OWNED_CONTENT = 'FETCH_BRAND_OWNED_CONTENT';
export const FETCHED_BRAND_OWNED_CONTENT = 'FETCHED_BRAND_OWNED_CONTENT';
export const SET_BRAND_OWNED_CONTENT_FILTER = 'SET_BRAND_OWNED_CONTENT_FILTER';

export const FETCH_BRAND_TOP_PUBLISHERS = 'FETCH_BRAND_TOP_PUBLISHERS';
export const FETCHED_BRAND_TOP_PUBLISHERS = 'FETCHED_BRAND_TOP_PUBLISHERS';
export const SET_BRAND_TOP_PUBLISHERS_FILTER = 'SET_BRAND_TOP_PUBLISHERS_FILTER';

export const FETCH_BRAND_TOP_KEYWORDS = 'FETCH_BRAND_TOP_KEYWORDS';
export const FETCHED_BRAND_TOP_KEYWORDS = 'FETCHED_BRAND_TOP_KEYWORDS';
export const SET_BRAND_TOP_KEYWORDS_FILTER = 'SET_BRAND_TOP_KEYWORDS_FILTER';

export const FETCH_BRAND_TOP_CONTENT_HUBS = 'FETCH_BRAND_TOP_CONTENT_HUBS';
export const FETCHED_BRAND_TOP_CONTENT_HUBS = 'FETCHED_BRAND_TOP_CONTENT_HUBS';
export const SET_BRAND_TOP_CONTENT_HUBS_FILTER = 'SET_BRAND_TOP_CONTENT_HUBS_FILTER';

export const FETCH_BRAND_CONTENT_OVER_TIME = 'FETCH_BRAND_CONTENT_OVER_TIME';
export const FETCHED_BRAND_CONTENT_OVER_TIME = 'FETCHED_BRAND_CONTENT_OVER_TIME';
export const SET_BRAND_CONTENT_OVER_TIME_FILTER = 'SET_BRAND_CONTENT_OVER_TIME_FILTER';
export const FETCH_BRAND_KEYWORDS_LIST = 'FETCH_BRAND_KEYWORDS_LIST';
export const FETCHED_BRAND_KEYWORDS_LIST = 'FETCHED_BRAND_KEYWORDS_LIST';

export const fetchBrandPaidContent = (clear, brandId) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().BrandProfile.paidContentList,
  fetchingActionType: FETCH_BRAND_PAID_CONTENT,
  fetchedActionType: FETCHED_BRAND_PAID_CONTENT,
  apiCall: filters => content.getBrandContent(brandId, filters),
});

export const fetchBrandOwnedContent = (clear, brandId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().BrandProfile.ownedContentList,
    fetchingActionType: FETCH_BRAND_OWNED_CONTENT,
    fetchedActionType: FETCHED_BRAND_OWNED_CONTENT,
    apiCall: filters => content.getBrandContent(brandId, filters),
  });

export const fetchBrandMetadata = (id) => dispatch =>
  fetchPayload({
    dispatch,
    fetchingActionType: FETCH_BRAND_METADATA,
    fetchedActionType: FETCHED_BRAND_METADATA,
    apiCall: () => brands.getBrandMetadata(id),
  });

export const fetchBrandsTopPublishers = (clear, id) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().BrandProfile.topPublisherList,
    fetchingActionType: FETCH_BRAND_TOP_PUBLISHERS,
    fetchedActionType: FETCHED_BRAND_TOP_PUBLISHERS,
    apiCall: filters => publishers.getBrandsPublishers(id, filters),
  });

export const fetchBrandsTopKeywords = (clear, id) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().BrandProfile.topKeywordList,
    fetchingActionType: FETCH_BRAND_TOP_KEYWORDS,
    fetchedActionType: FETCHED_BRAND_TOP_KEYWORDS,
    apiCall: filters => keywords.getBrandsKeywords(id, filters),
  });

export const fetchTopContentHubs = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().BrandProfile.topContentHubList,
    fetchingActionType: FETCH_BRAND_TOP_CONTENT_HUBS,
    fetchedActionType: FETCHED_BRAND_TOP_CONTENT_HUBS,
    apiCall: (filters) => hubs.getBrandHubs(entityId, filters),
  });

export const fetchBrandContentOverTime = (clear, brandId) => (dispatch, getState) =>
  fetchPayload({
    clear,
    dispatch,
    getState,
    store: getState().BrandProfile.contentOverTimeList,
    fetchingActionType: FETCH_BRAND_CONTENT_OVER_TIME,
    fetchedActionType: FETCHED_BRAND_CONTENT_OVER_TIME,
    apiCall: (filters) => content.getBrandContentOverTime(brandId, filters),
  });

export const fetchComparedBrands = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().BrandsList.brandsList,
    fetchingActionType: FETCH_BRANDS_LIST,
    fetchedActionType: FETCHED_BRANDS_LIST,
    apiCall: (filters) => brands.getBrandsList(filters),
  });

export const fetchBrandKeywords = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().KeywordsList.keywordsList,
    fetchingActionType: FETCH_KEYWORDS_LIST,
    fetchedActionType: FETCHED_KEYWORDS_LIST,
    apiCall: (filters) => keywords.getBrandsKeywords(entityId, filters),
  });

export const fetchBrandCategories = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().CategoriesList.categoriesList,
    fetchingActionType: FETCH_CATEGORIES_LIST,
    fetchedActionType: FETCHED_CATEGORIES_LIST,
    apiCall: (filters) => categories.getBrandCategories(entityId, filters),
  });

export const fetchBrandPublishers = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().PublishersList.publishersList,
    fetchingActionType: FETCH_PUBLISHERS_LIST,
    fetchedActionType: FETCHED_PUBLISHERS_LIST,
    apiCall: (filters) => publishers.getBrandsPublishers(entityId, filters),
  });
